import jsPDF from "jspdf";
import { Style, Section } from "./ClasesImpresion";
import moment from "moment";
import printBlob from "../../helpers/printBlob";

export async function printTicketProduccion(DetallesVenta, Venta, extImg = 'png') {
    const mmPageSize = [80, 2000];
    const ptPageSize = mmPageSize.map(coord => coord * 2.83465);

    var doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: ptPageSize
    });

    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    // Encabezado
    const tituloStyle = new Style(11, 'bold', 1, 'center');
    const tituloSection = new Section(doc, 4, 6, tituloStyle, pageWidth - 8);
    tituloSection.write('TICKET DE PRODUCCIÓN');
    tituloSection.write('Y DESPACHO');

    const subTituloStyle = new Style(8, 'normal', 1, 'center');
    const subTituloSection = new Section(doc, 4, tituloSection.y + 2, subTituloStyle, pageWidth - 8);
    if (Venta && Venta.Empresa) {
        subTituloSection.write(Venta.Empresa.toUpperCase());
    }

    doc.setDrawColor(0, 0, 0);
    doc.line(4, subTituloSection.y + 2, 76, subTituloSection.y + 2);

    // Datos del comprobante y cliente
    const infoStyle = new Style(8, 'normal', 1);
    const infoBoldStyle = new Style(8, 'bold', 1);
    const infoSection = new Section(doc, 4, subTituloSection.y + 5, infoStyle, pageWidth - 8);

    const docNombre = (Venta && Venta.TipoComprobante ? Venta.TipoComprobante : 'VENTA').toUpperCase();
    const docNumero = `${Venta && Venta.Serie ? Venta.Serie.toUpperCase() + ' - ' : ''}${Venta && Venta.NumeroComprobante ? Venta.NumeroComprobante : ''}`;
    infoSection.write(`${docNombre}: ${docNumero}`, infoBoldStyle);
    infoSection.write(`FECHA: ${moment(Venta && Venta.FechaEmision ? Venta.FechaEmision : new Date()).format('DD-MM-YYYY HH:mm')}`);

    if (Venta && Venta.RazonSocial) {
        infoSection.write(`CLIENTE: ${Venta.RazonSocial}`, infoBoldStyle);
    }
    if (Venta && Venta.NroTipoDocumento) {
        infoSection.write(`DOC: ${Venta.NroTipoDocumento}`);
    }
    if (Venta && (Venta.Direccion || Venta.ClienteDireccion)) {
        infoSection.write(`DIR: ${Venta.Direccion || Venta.ClienteDireccion}`);
    }
    if (Venta && Venta.Celular) {
        infoSection.write(`TEL/CEL: ${Venta.Celular}`);
    }
    if (Venta && Venta.NombreEmpleado) {
        infoSection.write(`VENDEDOR: ${Venta.NombreEmpleado} ${Venta.ApellidoEmpleado || ''}`.trim());
    }
    if (Venta && Venta.Observacion) {
        infoSection.write(`OBS: ${Venta.Observacion.toUpperCase()}`, infoBoldStyle);
    }

    doc.line(4, infoSection.y + 2, 76, infoSection.y + 2);

    // Formatear items para tabla (sólo productos, cantidades y medidas, sin precios ni totales)
    const itemsTabla = [];
    (DetallesVenta || []).forEach((prod, index) => {
        let descripcion = `${prod.NombreProducto || prod.descripcion || ''}`;
        if (prod.NombrePresentacion && !descripcion.includes(prod.NombrePresentacion)) {
            descripcion += ` (${prod.NombrePresentacion})`;
        }

        // MedidasExtras (ancho x alto x cantidad)
        let medidasTexto = '';
        const rawMedidas = prod.MedidasExtras || prod.medidasExtras;
        if (rawMedidas) {
            try {
                const parsed = typeof rawMedidas === 'string' ? JSON.parse(rawMedidas) : rawMedidas;
                if (parsed && Array.isArray(parsed.areaRows) && parsed.areaRows.length > 0) {
                    const desglose = parsed.areaRows
                        .map(r => `  • ${r.ancho || 0} x ${r.alto || 0} (Cant: ${r.cantidad || 1})`)
                        .join('\n');
                    medidasTexto = `\n[MEDIDAS]:\n${desglose}`;
                    if (parsed.factorDesperdicio) {
                        medidasTexto += `\n  (Factor Desp: ${parsed.factorDesperdicio})`;
                    }
                }
            } catch (e) {}
        }

        // Medidas de Receta (si aplica)
        const rawReceta = prod.medidasReceta || prod.MedidasReceta;
        if (rawReceta) {
            try {
                const mr = typeof rawReceta === 'string' ? JSON.parse(rawReceta) : rawReceta;
                if (mr && mr.W && mr.H) {
                    medidasTexto += `\n[RECETA: Ancho ${mr.W}m x Alto ${mr.H}m]`;
                }
            } catch (e) {}
        }

        const descripcionCompleta = descripcion + medidasTexto;
        const cant = prod.Cantidad !== undefined ? prod.Cantidad : 1;
        const unidad = prod.Unidad || prod.unidadMedida || prod.unidadMedidas || 'UND';

        itemsTabla.push({
            item: String(index + 1),
            cant: String(cant),
            unidad: String(unidad),
            descripcion: descripcionCompleta
        });
    });

    doc.autoTable({
        body: itemsTabla,
        startY: infoSection.y + 4,
        margin: { left: 4, right: 4 },
        showHead: 'firstPage',
        theme: 'plain',
        headStyles: {
            fontSize: 7.5,
            fontStyle: 'bold',
            cellPadding: 1
        },
        bodyStyles: {
            fontSize: 7.5,
            cellPadding: 1.5,
            valign: 'top'
        },
        columns: [
            { header: '#', dataKey: 'item' },
            { header: 'CANT', dataKey: 'cant' },
            { header: 'UND', dataKey: 'unidad' },
            { header: 'PRODUCTO / MEDIDAS', dataKey: 'descripcion' }
        ],
        columnStyles: {
            item: { columnWidth: 5, halign: 'center' },
            cant: { columnWidth: 10, halign: 'right', fontStyle: 'bold' },
            unidad: { columnWidth: 10, halign: 'center' },
            descripcion: { columnWidth: 47, halign: 'left' }
        }
    });

    let finalY = doc.autoTable.previous.finalY + 3;
    doc.line(4, finalY, 76, finalY);

    // Pie de ticket
    const pieStyle = new Style(7, 'italic', 1, 'center');
    const pieSection = new Section(doc, 4, finalY + 4, pieStyle, pageWidth - 8);
    pieSection.write('*** CONTROL INTERNO / PRODUCCIÓN - DESPACHO ***');
    pieSection.write('NO VÁLIDO COMO COMPROBANTE DE PAGO');

    doc.autoPrint();
    printBlob(doc.output('bloburl'));
}

export default printTicketProduccion;
